import React from 'react';
import { observer } from 'mobx-react';

import { useStores } from '@/hooks/use-stores';

import StaticInfoSection from './StaticInfoSection/StaticInfoSection';
import RealtimeDataSection from './RealtimeDataSection/RealtimeDataSection';
import AlertsSection from './AlertsSection/AlertsSection';
import { Container } from './UniversalAssetInfo.styles';

interface UniversalAssetInfoProps {
  deviceId: string;
}

const UniversalAssetInfo = observer(({ deviceId }: UniversalAssetInfoProps) => {
  const { stationStore, controlCenterStore, devicesStore } = useStores();

  const deviceFromStationStore = stationStore.getDeviceById(deviceId);
  if (!deviceFromStationStore) return null;
  const deviceFromDevicesStore = devicesStore.getDeviceById(deviceId);
  const schema = controlCenterStore.getDeviceDrawerSchemaForDevice(deviceFromStationStore);
  return (
    <Container>
      <StaticInfoSection
        deviceFromStationStore={deviceFromStationStore}
        deviceFromDevicesStore={deviceFromDevicesStore}
        staticInfo={schema?.staticInfo ?? []}
      />
      <RealtimeDataSection device={deviceFromStationStore} schema={schema} />
      <AlertsSection deviceId={deviceId} />
    </Container>
  );
});

export default UniversalAssetInfo;

